export default __webpack_public_path__ + "static/media/js.33c19307.png";